import { render, staticRenderFns } from "./NameRow.vue?vue&type=template&id=1a9c193d&"
import script from "./NameRow.ts?vue&type=script&lang=ts&"
export * from "./NameRow.ts?vue&type=script&lang=ts&"
import style0 from "./NameRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports